import styled from "styled-components";

export const Container = styled.div`
  padding: 32px 24px 48px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  color: #212121;
`;

export const PeriodSelect = styled.select`
  border: 1px solid #d7d7d7;
  border-radius: 999px;
  background: #fff;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const SummaryCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
`;

export const SummaryTop = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconWrapper = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: ${(props) => props.bg ?? "#fdf2ec"};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18);
  img {
    width: 24px;
    height: 24px;
    filter: brightness(0) saturate(120%);
  }
`;

export const SummaryLabel = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #7a7a7a;
`;

export const SummaryValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: #212121;
`;

export const MainSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 1000px) {
    grid-template-columns: 3fr 2fr;
  }
`;

export const ChartCard = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  border: 1px solid #ececec;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
`;

export const RankCard = styled.div`
  background: #fff;
  border-radius: 18px;
  border: 1px solid #ececec;
  padding: 16px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
`;
